import React from 'react'
import { useSelector } from 'react-redux';
import { useProjectDetails } from './hooks/useProjectDetails';
import { ModalProvider } from './provider/ModalProvider';
import { WrapperFiche } from './components/WrapperFiche';
import { ContainerFiche } from './components/ContainerFiche';


export const ProjectFiche = () => {

    const auth = useSelector((state) => state.auth);

    const {
        errorPage,
        isLoading,
        query,
        project,
        getProjectDetails
    } = useProjectDetails();


    const propsContainer = {
        auth,
        project,
        query,
        getProjectDetails
    }

    return (
        <WrapperFiche error={errorPage} loading={isLoading}>
            <ModalProvider >
                <ContainerFiche {...propsContainer} />
            </ModalProvider>
        </WrapperFiche>
    )
}
